// Copyright (c) 2016 Deere & Company

import Report, {getDefaultState} from '../state/report';
import actions from '../../actions-list';

const updateLaborRateHistoryReport = (state, action) =>
    Report.update(state, {
        $set: action.data
    });

const resetLaborRateHistoryReport = () => getDefaultState();

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.CREATE_LABOR_RATE_HISTORY_REPORT_SUCCESS]: updateLaborRateHistoryReport,
        [actions.RESET_LABOR_RATE_HISTORY_REPORT]: resetLaborRateHistoryReport
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/labor-rate-history/reducers/report.js